// extracted by mini-css-extract-plugin
export var link = "FooterLinks-module--link--hGSsn";
export var root = "FooterLinks-module--root--cXezs";